module.exports = __webpack_public_path__ + "static/media/carroussel_01.a82b4cf9.jpg";